import { render, staticRenderFns } from "./CreateNewUserAccount.vue?vue&type=template&id=53ec8bfd&scoped=true"
import script from "./CreateNewUserAccount.vue?vue&type=script&lang=js"
export * from "./CreateNewUserAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateNewUserAccount.vue?vue&type=style&index=0&id=53ec8bfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec8bfd",
  null
  
)

export default component.exports